import { render } from "./PaginatedSelect.vue?vue&type=template&id=935fd536&scoped=true"
import script from "./PaginatedSelect.vue?vue&type=script&lang=js"
export * from "./PaginatedSelect.vue?vue&type=script&lang=js"

import "./PaginatedSelect.vue?vue&type=style&index=0&id=935fd536&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-935fd536"]])

export default __exports__